import { Typography } from '@design-system/components/typography/typography';
import { BundleDetailsCard } from './BundleDetailsCard';
import { BundlesContentTable } from './BundlesContentTable';
import { Button } from '@design-system/components/button/button';
import {
  BundlesCards,
  BundlesTable,
} from '../viewModel/subscriptionBundle.vm.mapper';

export type SubscriptionBundlesProps = {
  list: BundlesTable | null;
  cards: BundlesCards;
  searchText: string;
  search: (value: string) => void;
  editMode: boolean;
  setEditMode: () => void;
  cancel: () => void;
  save: () => void;
  showSubscriptionBundles: boolean;
};

export const SubscriptionBundles = ({
  cards,
  editMode,
  setEditMode,
  cancel,
  save,
  showSubscriptionBundles,
  ...p
}: SubscriptionBundlesProps) => {
  if (!showSubscriptionBundles) return null;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <Typography variant="body" size="medium" color="N-80">
          Subscription Offers
        </Typography>
        <div>
          {!editMode ? (
            <Button
              variant="filled"
              size="large"
              color="neutral"
              onClick={() => setEditMode()}
            >
              Edit
            </Button>
          ) : (
            <div className="flex justify-end items-center gap-6">
              <Button
                variant="text"
                size="large"
                color="neutral"
                onClick={() => cancel()}
              >
                Cancel
              </Button>
              <Button
                variant="filled"
                size="large"
                color="neutral"
                onClick={() => save()}
              >
                Save
              </Button>
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <div className="grid grid-rows-2 md:grid-cols-2 md:grid-rows-1 gap-4 w-full">
          {cards.map((card) => (
            <BundleDetailsCard
              card={card}
              editMode={editMode}
              key={card.bundleId}
            />
          ))}
        </div>
        {!p.list ? null : <BundlesContentTable {...p} editMode={editMode} />}
      </div>
    </div>
  );
};
